module.exports = __webpack_public_path__ + "static/img/Bachelor_010827.2a76ac0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010827.jpg
// module id = 258
// module chunks = 0